import { Skeleton, TableCell, TableRow } from "@mui/material";
export default function TableSkeleton({ columns = 4, rows = 5 }) {
  return Array.from({ length: rows }, (_, row) => (
    <TableRow key={row}>
      {Array.from({ length: columns }, (_, col) => (
        <TableCell key={col}>
          <Skeleton
            aria-label={col === 0 ? "Loading row" : undefined}
            height={28}
          />
        </TableCell>
      ))}
    </TableRow>
  ));
}
